import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'caret-up', 'CaretUp', [["path",{"d":"M18 14l-6 -6l-6 6h12"}]]);